// extracted by mini-css-extract-plugin
export default {"root":"xo__Ri","content":"GhxTTJ","username":"TjWkMH","isMobile":"IYls3_","time":"r0YE1k","badge":"U6zSMi","roleIcon":"UrDiRp","roleBadge":"DD63ip","row":"EMHKZ0","divider":"rTencg"};